import { Component, Input } from '@angular/core';
import { CartService } from '../../../../services/cart';
import { Router } from '@angular/router';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { UrlSlugifyService } from '../../../../services/url-slugify';
import { DailyOfferStateService } from '../../../../services/dailyOfferState';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrl: './product.component.scss'
})
export class ProductComponent {
  @Input() element: any;
  @Input() isAr: boolean = false;
  @Input() bybrand: boolean = false;
  isMobile: boolean = false;
  constructor(
    private cartService: CartService,
    private router: Router,
    private deviceService: DeviceDetectorService,
    private _slugify: UrlSlugifyService,
    public dailyOfferState: DailyOfferStateService
  ) {

  }

  ngOnInit() {
    //for fix product image image category
    if (this.router.url == "/category" || this.router.url.startsWith("/category/")) {
      this.bybrand = true;
    }

    this.isMobile = this.deviceService.isMobileDevice();
  }
  calcDis(newP: any, oldP: any) {

    const off = Math.round(((parseInt(oldP) - parseInt(newP)) / parseInt(oldP)) * 100);
    if (isNaN(off))
      return 0
    else
      return off
  }
  addToCart(product: any, quantiy: any) {

    this.cartService.addToCart(product);
  }
  fixImage(url: any) {

    return "https://backendproduction.blueboxpet.com/storage/app/public/" + url
  }


  productDetails(product: any) {
    this.router.navigate(['/product', this._slugify.slugify(product.name_en), product.id]);
  }
  detectNumberofCharacters(name: string) {
    return name.length < 25 && this.isMobile;
  }

}
